module.exports = __WEBPACK_EXTERNAL_MODULE_178__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/Subject"
// module id = 178
// module chunks = 0